<cipo-dialog-header [fullScreen]="'never'" testId="nutrient-dialog" closeTestId="nutrient-dialog-close">
    <div fxLayout fxLayoutAlign="space-between center" class="cipo--width--full">
        <div fxLayout fxLayoutAlign="start center" class="cipo--overflow--hidden">
            @if (versions().length > 0) {
                <button
                    mat-mini-fab
                    color="accent"
                    class="m-y-xs m-r"
                    [matMenuTriggerFor]="versionsMenu"
                    [disabled]="isVersionsBusy()"
                    [attr.aria-label]="'a11y.pdfMarkups.versions' | translate"
                    data-testid="nutrient-versions-trigger">
                    <mat-icon class="material-symbols-outlined" aria-hidden="true">history</mat-icon>
                </button>
                <mat-menu #versionsMenu="matMenu">
                    @for (version of versions(); track version.version) {
                        <button
                            mat-menu-item
                            (click)="changeVersion(version)"
                            [disabled]="version.version === selectedVersion()?.version"
                            data-testid="nutrient-version-item">
                            V{{ version.version }} - {{ version.createdOn | itvDateTime }}
                            @if (version.isCurrent) {
                                ({{ "pdfMarkups.current" | translate }})
                            }
                        </button>
                    }
                </mat-menu>
            }
            <h5 class="cipo--text--ellipsed m-r m-0" [title]="selectedFile().name">{{ selectedFile().name }}</h5>
        </div>
        @if (data.isMarkup) {
            <button
                mat-icon-button
                class="m-l"
                [matMenuTriggerFor]="usersMenu"
                [attr.aria-label]="'a11y.pdfMarkups.connectedUsers' | translate: { count: connectedUsers().length }"
                data-testid="nutrient-connected-users-trigger">
                <mat-icon
                    aria-hidden="true"
                    [matBadge]="connectedUsers().length"
                    [matBadgeHidden]="connectedUsers().length === 0"
                    matBadgeColor="warn"
                    matBadgeSize="small">
                    group
                </mat-icon>
            </button>
            <mat-menu #usersMenu="matMenu" xPosition="before">
                <span mat-menu-item class="cipo--pointers-events--none">
                    <strong>{{ "pdfMarkups.connectedUsers" | translate }}</strong>
                </span>

                @for (user of connectedUsers(); track user.id) {
                    <span mat-menu-item class="cipo--pointers-events--none">
                        {{ user.firstName }} {{ user.lastName }}
                    </span>
                } @empty {
                    <span mat-menu-item class="cipo--pointers-events--none">{{ "pdfMarkups.none" | translate }}</span>
                }
            </mat-menu>
        }
    </div>
</cipo-dialog-header>
<mat-dialog-content class="cipo--position--relative">
    <div
        id="nutrient-container"
        class="cipo--height--full"
        [class.cipo--display--none]="!!viewerLoadError()"
        data-testid="nutrient-container"></div>
    @if (viewerLoadError()) {
        <div
            class="nutrient-load-error cipo--position--absolute cipo--border-radius--sm p-a-lg"
            role="alert"
            data-testid="nutrient-load-error">
            {{ viewerLoadError() | translate }}
        </div>
    }
    @if (showClickMessage()) {
        <div
            class="cipo--position--absolute cipo-bg--primary-900 cipo-text--black-50 cipo--width--fit-content cipo--border-radius--sm p-x-lg p-y-xs"
            style="bottom: 20px; left: 50%; transform: translateX(-50%)"
            data-testid="nutrient-place-icon-hint">
            <strong>{{ "pdfMarkups.placeIcon" | translate }}</strong>
        </div>
    }
</mat-dialog-content>
@if (data.documents.length > 1) {
    <mat-dialog-actions>
        <div fxLayout fxLayoutGap="12px" fxLayoutAlign="space-between center" class="cipo--width--full m-x-xl">
            <div fxLayout fxFlex="grow" class="cipo--overflow-x--auto" fxLayoutGap="12px" fxLayoutAlign="start center">
                <button
                    mat-mini-fab
                    [disabled]="selectedFileIndex() < 1"
                    class="m-l"
                    (click)="selectFile('prev')"
                    [matTooltip]="'general.previous' | translate"
                    [attr.aria-label]="'general.previous' | translate"
                    data-testid="nutrient-gallery-prev">
                    <mat-icon class="material-symbols-outline" aria-hidden="true">arrow_left</mat-icon>
                </button>
                @for (document of data.documents; track document.versionId; let index = $index) {
                    @let isSelected = index === selectedFileIndex();
                    <cipo-img-base64
                        class="galery-file"
                        role="button"
                        tabindex="0"
                        data-testid="nutrient-gallery-item"
                        [attr.aria-label]="'a11y.pdfMarkups.selectDocument' | translate: { name: document.name }"
                        [attr.aria-current]="isSelected ? 'true' : null"
                        [class.selected]="isSelected"
                        [base64]="document.thumbnail200 || document.thumbnail50"
                        (click)="loadDocument(document.versionId, index)"
                        (keydown.enter)="loadDocument(document.versionId, index)"
                        (keydown.space)="$event.preventDefault(); loadDocument(document.versionId, index)"
                        [mimetype]="document.mimeType"
                        [height]="isSelected ? 50 : 40"></cipo-img-base64>
                }
            </div>
            <button
                fxFlex="none"
                mat-mini-fab
                (click)="selectFile('next')"
                [disabled]="selectedFileIndex() >= data.documents.length - 1"
                class="m-r"
                [matTooltip]="'general.next' | translate"
                [attr.aria-label]="'general.next' | translate"
                data-testid="nutrient-gallery-next">
                <mat-icon class="material-symbols-outline" aria-hidden="true">arrow_right</mat-icon>
            </button>
        </div>
    </mat-dialog-actions>
}
